/**
 * Service pour les motifs de perte ("Pas intéressé")
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const lossReasonsService = {
  list: () => api.get(endpoints.lossReasons.list())
}
